import ApiService from '@/services/apiService';
import { mapState } from 'vuex';
import { get } from 'lodash';
import { themesMixin } from '@/utils/themes';
export default {
  name: 'CoreDtwinCsvExportd',
  mixins: [themesMixin],
  props: {
    dtwinId: {
      type: Number,
      required: true
    },
    tenantId: {
      type: Number,
      required: true
    },
    ressource: {
      type: String,
      required: true
    }
  },
  data: function () {
    const start = new Date(new Date() - 86400000 * 2);
    const end = new Date();
    return {
      start,
      end,
      exportQuery: {
        dtwinId: this.dtwinId,
        time: {
          from: start,
          to: end
        }
      },
      exportVariables: [],
      variables: [],
      variablesIsUpdating: true,
      formValid: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    backgroundColor() {
      return `background-color: ${this.vuetifyColorHex('info')}`;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    borderColor() {
      return this.UiTheme ? 'rgba(255, 255, 255, 0.25)' : 'transparent';
    }
  },
  watch: {},
  created() {
    this.fetchVariables();
  },
  methods: {
    datePicked(dateObject) {
      this.start = new Date(dateObject.from * 1000);
      this.end = new Date(dateObject.to * 1000);
      this.exportQuery = {
        ...this.exportQuery,
        time: {
          from: this.start,
          to: this.end
        }
      };
    },
    variablesChanged() {
      this.exportQuery = {
        ...this.exportQuery,
        variables: this.exportVariables
      };
      this.formValid = !!this.exportVariables.length;
    },
    async fetchVariables() {
      this.variablesIsUpdating = true;
      const states = await ApiService.digitalTwinFetchStates(this, this.dtwinId).then(res => {
        return res;
      }).catch(error => {
        console.error({
          error
        });
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorLoadingParsedPackets'), 'error');
      });
      this.variables = states.map(state => {
        const measurement = get(state, 'properties.title');
        const stateId = get(state, 'id');
        const key = get(state, 'key');
        if (!measurement) {
          return null;
        }
        return {
          variable: measurement,
          bindingIds: stateId,
          key
        };
      }).sort((a, b) => {
        return a.key.localeCompare(b.key, undefined, {
          numeric: true
        });
      });
      this.variablesIsUpdating = false;
    }
  }
};